import CameraPreview from './CameraPreview';

export default CameraPreview;